import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { style: {"overflow":"hidden","text-overflow":"ellipsis"} }

import { computed, ref, toRef, watch } from 'vue';
import { useHakuComponent } from './haku';
import { setNodes, useNimikeKategoria } from '@/methods/nimikkeetComposables';
import ComHakuSuunnittelutiedotOminaisuudet from './ComHakuSuunnittelutiedotOminaisuudet.vue';
import { Edit } from '@element-plus/icons-vue'
import ComCancelButton from '@/components/common/buttons/ComCancelButton.vue';
import ComCascaderSearch from '@/components/common/ComCascaderSearch.vue';
import { useHakuSelection } from '@/methods/hakuSelectionComposables';


export default /*@__PURE__*/_defineComponent({
  __name: 'ComHakuSuunnittelutiedot',
  setup(__props) {

const { searchForm, selectedNodes, isSelected, showHeading } = useHakuComponent()
const { model: hakuModel } = useHakuSelection(selectedNodes)
const suunnittelutiedot = computed(() => searchForm.value.nimike)
const { nimikeKategoriat } = useNimikeKategoria(toRef(true))
const showTiedot = ref<number[]>([])
const nodes = computed(() => setNodes(nimikeKategoriat.value ?? []))

const isSelectedNimike = (id : number | undefined) => {
    return id !== undefined && showTiedot.value?.indexOf(id) !== -1
}
const removeFromSelected = (id : number) => {
    showTiedot.value = showTiedot.value.filter(s => s !== id)
}
const cascaderFocus = (id: number | undefined) => {
    if(id === undefined) {
        return
    }
    if(isSelectedNimike(id) === false) {
        showTiedot.value.push(id)
    }
    else {
        removeFromSelected(id)
        
        const index = searchForm.value.nimike?.findIndex(n => n.id === id) ?? -1
        if(index !== -1 && searchForm.value.nimike) {
            searchForm.value.nimike[index] = { id: id }
        }
    }
}

watch(() => selectedNodes.value.map(node => node[2]), (newIds, oldIds) => {
    const removedIds = oldIds.filter(id => !newIds.includes(id))
    const addedIds = newIds.filter(id => !oldIds.includes(id))

    removedIds.forEach(id => {
        removeFromSelected(id);
        searchForm.value.nimike = searchForm.value.nimike?.filter(n => n.id !== id) || []
    })

    addedIds.forEach(id => {
        if (!searchForm.value.nimike?.find(n => n.id === id)) {
            searchForm.value.nimike?.push({ id })
        }
    })

    if (newIds.length === 0) {
        showTiedot.value = []
    }
})

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_cascader_panel = _resolveComponent("el-cascader-panel")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(showHeading)(1))
      ? (_openBlock(), _createElementBlock("h3", _hoisted_1, "Suunnittelutiedot"))
      : _createCommentVNode("", true),
    _createVNode(_component_el_form, {
      model: suunnittelutiedot.value,
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
      ref: "form",
      inline: false,
      size: "small"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            (_unref(isSelected)('nimike'))
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 0,
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(ComCascaderSearch, {
                          modelValue: _unref(hakuModel),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(hakuModel) ? (hakuModel).value = $event : null))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_cascader_panel, {
                          options: nodes.value,
                          props: {
                        disabled: false,
                        multiple: true,
                        checkOnClickLeaf: false,
                    },
                          size: "small",
                          modelValue: _unref(selectedNodes),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selectedNodes) ? (selectedNodes).value = $event : null)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(({ node, data }) => [
                            (!node.isLeaf || !node.checked)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(data.label), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                  _createVNode(_component_el_link, {
                                    icon: _unref(Edit),
                                    onClick: ($event: any) => (cascaderFocus(data.value))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_4, "   " + _toDisplayString(data.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["icon", "onClick"])
                                ]))
                          ]),
                          _: 1
                        }, 8, ["options", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (showTiedot.value.length > 0)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 1,
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Tarkenna nimikkeiden haku termejä", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchForm).nimike, (selectedNimike, i) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: selectedNimike.id
                      }, [
                        (isSelectedNimike(selectedNimike.id) && _unref(searchForm).nimike)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(ComHakuSuunnittelutiedotOminaisuudet, {
                                show: isSelectedNimike(selectedNimike.id),
                                modelValue: _unref(searchForm).nimike[i],
                                "onUpdate:modelValue": ($event: any) => ((_unref(searchForm).nimike[i]) = $event)
                              }, null, 8, ["show", "modelValue", "onUpdate:modelValue"]),
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(ComCancelButton, {
                                    onClick: ($event: any) => (cascaderFocus(selectedNimike.id))
                                  }, {
                                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                      _createTextVNode("Peruuta", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(isSelected)('nimike-tasmennys'))
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 2,
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "Nimikkeen täsmennys" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(searchForm)['nimike-tasmennys'],
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchForm)['nimike-tasmennys']) = $event)),
                          placeholder: "Hae kaikista nimikkeistä tai valituista",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ], 64))
}
}

})